import ArrowDownRightIcon from "@heroicons/react/24/solid/ArrowDownRightIcon";
import ChevronRightIcon from "@heroicons/react/24/outline/ChevronRightIcon";
import MagnifyingGlassCircleIcon from "@heroicons/react/24/outline/MagnifyingGlassCircleIcon";
import MapPinIcon from "@heroicons/react/24/outline/MapPinIcon";
import SwatchIcon from "@heroicons/react/24/outline/SwatchIcon";
import { PLAUSIBLE_GOAL_KEYS } from "@/@core/constants/plausible";
import { usePlausible } from "next-plausible";
import { SearchOptionDataProps } from "@/components/views/modals/search/types";
import { useTranslation } from "@/hooks/translationContext";

interface Props {
  searchType: "district" | "service" | "company" | "venue";
  data: SearchOptionDataProps[] | any[];
  onClose: () => void;
  clickedAllData: (msg: string) => void;
  handleShowPreferredData?: (value: boolean) => void;
  showPreferredData?: boolean;
  selectedData: SearchOptionDataProps;
}

export default function ListItems(props: Props) {
  const { t } = useTranslation();
  const plausible = usePlausible();
  const notIncludes = () => {
    return ["venue", "company"].includes(props.searchType);
  };

  const icons = {
    company: ArrowDownRightIcon,
    service: SwatchIcon,
    venue: SwatchIcon,
    district: MapPinIcon,
  };

  const getIcon = () => {
    const Icon = icons[props.searchType];
    return <Icon className="size-4"></Icon>;
  };

  const sendPlausibleEvent = (title) => {
    plausible(PLAUSIBLE_GOAL_KEYS.SEARCH_DROPDOWN_ITEM_CLICKED, {
      props: {
        title,
        type: props.searchType,
      },
    });
  };

  function ListItem({ item }: any) {
    return (
      <div
        role="option"
        aria-selected={props.selectedData?.slug == item.slug}
        aria-disabled={false}
        className={`${props.searchType === "company" ? "py-3" : "py-4"} cursor-pointer flex items-center justify-between border-b border-gray-200`}
        onClick={() => {
          sendPlausibleEvent(item.title);
          item.onClick?.();
          props.onClose();
        }}
      >
        <div className="flex items-center gap-2 text-sm text-primary font-medium">
          {getIcon()}
          <div className="flex flex-col gap-1">
            <div>{item.title}</div>
            {item.description && (
              <span className="text-gray-400 text-xs font-medium">
                {item.description}
              </span>
            )}
          </div>
        </div>

        <ChevronRightIcon className="text-primary size-4" />
      </div>
    );
  }

  return (
    <>
      {!notIncludes() && (
        <div
          className="py-4 cursor-pointer flex items-center justify-between"
          onClick={() => {
            props.onClose();
            sendPlausibleEvent("all-button");

            if (props.searchType === "service")
              props.clickedAllData(t("search-all-services"));
            else if (props.searchType === "district")
              props.clickedAllData(t("search-all-districts"));
          }}
        >
          <div className="flex items-center gap-2 text-sm text-primary font-medium">
            {getIcon()}

            {props.searchType == "service"
              ? t("search-all-services-action")
              : t("search-all-districts-action")}
          </div>

          <MagnifyingGlassCircleIcon className="size-4" />
        </div>
      )}

      {props.data.map((item, index) => {
        return (
          <>
            <ListItem key={index} item={item} />
            {Array.isArray(item.childItems) && item.childItems?.length > 0 && (
              <div className="pl-4">
                <span className="text-xs">
                  Yakın semtleri aşağıda görebilirsiniz
                </span>
                {item.childItems.map((childItem, childIndex) => (
                  <ListItem key={childIndex} item={childItem} />
                ))}
              </div>
            )}
          </>
        );
      })}

      {props?.showPreferredData && (
        <div
          className="py-5 cursor-pointer flex items-center justify-between border-b border-gray-200"
          onClick={() => {
            props?.handleShowPreferredData(false);
          }}
        >
          <div className="flex items-center gap-2 text-sm text-primary font-bold">
            {getIcon()}
            <div className="flex flex-col gap-1">
              <div>Başka Bir Hizmet Aramak İstiyorum</div>
            </div>
          </div>

          <ChevronRightIcon className="text-primary size-4" />
        </div>
      )}
    </>
  );
}
